import { FormikProvider, useFormik, Form, FormikHelpers } from 'formik';
import * as Yup from "yup";
import { Link as RouterLink } from "react-router-dom";
import React from 'react';
import { Box, TextField, CircularProgress, Button } from "@mui/material";
import { ArrowBackRounded } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";

export interface IRecoverPasswordValues {
  email: string,
}

interface IRecoverPasswordProps {
  handleSubmitProp: (values: IRecoverPasswordValues, actions: FormikHelpers<IRecoverPasswordValues>) => void
}

const RecoverPasswordForm: React.FC<IRecoverPasswordProps> = ({ handleSubmitProp }) => {

  const RecoverPasswordSchema = Yup.object().shape({
    email: Yup.string().email('Endereço de e-mail inválido').required('E-mail obrigatorio')
  })

  const formik = useFormik({
    initialValues: { email: '' },
    validationSchema: RecoverPasswordSchema,
    onSubmit: (values, actions) => handleSubmitProp(values, actions)
  })

  const { errors, touched, isSubmitting, handleSubmit, getFieldProps } = formik

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <TextField
          fullWidth
          autoComplete="email"
          type="email"
          label="Email"
          placeholder="seu@email.com"
          {...getFieldProps('email')}
          inputProps={{ 'data-testid': 'email' }}
          error={Boolean(touched.email && errors.email)}
          helperText={touched.email && errors.email}
          sx={{ mb: 2.5 }}
        />

        <LoadingButton
          fullWidth
          size="large"
          type="submit"
          variant="contained"
          color="primary"
          loading={isSubmitting}
          loadingIndicator={<CircularProgress color="inherit" size={18} />}
          sx={{ height: 54, fontSize: '15px', fontWeight: 600 }}
        >
          Enviar link de recuperação
        </LoadingButton>

        <Box sx={{ textAlign: 'center', mt: 2 }}>
          <Button component={RouterLink} to="/login" variant="text" color="secondary" startIcon={<ArrowBackRounded />} sx={{ fontWeight: 600 }}>
            Voltar ao login
          </Button>
        </Box>
      </Form>
    </FormikProvider>
  )
}

export default RecoverPasswordForm
